import { motion } from "framer-motion";
import { Star } from "lucide-react";
import { cn } from "./utils/cn";

export function Reveal({ children, delay = 0, y = 16, className }) {
  return (
    <motion.div
      initial={{ opacity: 0, y }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-40px" }}
      transition={{ duration: 0.55, delay, ease: [0.22, 1, 0.36, 1] }}
      className={className}
    >
      {children}
    </motion.div>
  );
}

export function Stars({ rating, size = 14, className }) {
  return (
    <span className={cn("relative inline-flex", className)} aria-label={`${rating} out of 5`}>
      <span className="flex gap-0.5 text-line">
        {[0, 1, 2, 3, 4].map((i) => (
          <Star key={i} size={size} fill="currentColor" strokeWidth={0} />
        ))}
      </span>
      <span
        className="absolute inset-0 flex gap-0.5 overflow-hidden text-gold"
        style={{ width: `${(rating / 5) * 100}%` }}
      >
        {[0, 1, 2, 3, 4].map((i) => (
          <Star key={i} size={size} fill="currentColor" strokeWidth={0} className="shrink-0" />
        ))}
      </span>
    </span>
  );
}

export function Card({ children, className }) {
  return (
    <div className={cn("rounded-2xl border border-line bg-card p-5 shadow-card", className)}>{children}</div>
  );
}

export function CardTitle({ children }) {
  return <h3 className="mb-4 text-[15px] font-bold text-ink">{children}</h3>;
}
